import React, { forwardRef } from 'react';
import { Box, FormControlLabel, Checkbox } from '@material-ui/core';
import { Controller } from 'react-hook-form';
import MessageMLStyled from './MessageMLStyles';

export default forwardRef(
  ({ label, queryType, name, content, control, ...props }, fRef) => {
    return (
      <MessageMLStyled>
        <Box
          className="init-message-wrap checkbox-radio-disabled-color"
          ref={fRef}
        >
          <Controller
            render={(pr) => (
              <FormControlLabel
                {...props}
                variant="standard"
                checked={pr.value ?? false}
                control={<Checkbox color="primary" />}
                label={<Box color="#000">{label}</Box>}
                onChange={(e) => pr.onChange(e.target.checked)}
                disabled={queryType === 'detail'}
              />
            )}
            label=""
            name={name}
            variant="standard"
            control={control}
          />
          <Box className="message-content">{content}</Box>
          {props?.children}
        </Box>
      </MessageMLStyled>
    );
  },
);
